<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-12 m-bottom" @click="redirectBanner(path1.url)">
        <img class="img1" :src="path1.image" :alt="translateMain.freeTour" width="913" height="522" loading="lazy"/>
      </div>
      <div v-if="!isMobile" class="col-lg-4 col-12 d-flex justify-content-end" @click="redirectBanner(path2.url)">
        <img class="img2" :src="path2.image" :alt="translateMain.titleBlog" width="288" height="522" loading="lazy"/>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { localeStore } from 'stores/locale'
  import { mapState } from 'pinia'
  import translateMain from 'tradutors/menu'
  import { isMobile } from 'views/shared/utils/mobile'

  export default defineComponent({
    name: 'BannerFreeTour',
    props: ['path1', 'path2'],
    computed: {
      ...mapState(localeStore, ['locale']),
      translateMain: function () {
        if (this.locale === 'pt-br') {
          return translateMain.portugues
        } else {
          return translateMain.ingles
        }
      }
    },
    methods: {
      redirectBanner(url){
        window.location.href = url;
      }
    },
    data() {
      return {
        isMobile: isMobile(),
      }
    }
  })
</script>
<style scoped lang="css">
  .img1 {
    width: 913px;
    height: 522px;
    cursor: pointer;
  }
  .img2 {
    width: 288px;
    height: 522px;
    cursor: pointer;
  }

  .row {
    margin-top: 50px;
    padding-bottom: 48px;
  }
  
  @media screen and (max-width: 992px) {
    .img1 {
      width: 100%;
      object-fit: fill;
      height: auto;
    }
    .img2 {
      width: 100%;
      object-fit: fill;
      height: auto;
    }
    .m-bottom {
      margin-bottom: 50px;
    }    
  }
</style>
